import React from 'react'
import '@whereby.com/browser-sdk/embed'

import { Box, SimpleModal } from '@/components/lib'

/** Fixed Whereby embed options for every host join modal (web + calendar). */
const WHEREBY_EMBED_DISPLAY_NAME = 'Trial Administrator'

const wherebyEmbedStyle = { width: '100%', height: '700px' }

function modalTitle (meeting, participantDisplayId) {
  if (meeting?.name) return meeting.name
  if (participantDisplayId != null && String(participantDisplayId) !== '') {
    return `Meeting with ${participantDisplayId}`
  }
  return 'Video meeting'
}

/**
 * Host join flow: SimpleModal + `whereby-embed` with consistent attributes.
 * Pass `meeting={null}` to close. Requires `meeting.hostRoomUrl` when open.
 */
export default function WherebyMeeting ({ meeting, onClose, participantDisplayId }) {
  const roomUrl = meeting?.hostRoomUrl
  const isOpen = Boolean(roomUrl)

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onClose}
      header={modalTitle(meeting, participantDisplayId)}
      body={
        roomUrl
          ? (
            <Box>
              <whereby-embed
                room={roomUrl}
                displayName={WHEREBY_EMBED_DISPLAY_NAME}
                logo='off'
                lang='en'
                localization='off'
                background='off'
                style={wherebyEmbedStyle}
              />
            </Box>
            )
          : null
      }
    />
  )
}
